import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {CompanyStandardForm} from 'src/app/compliance-standards/CompanyStandardForm';
import {ComplianceStandardsBrowserShell} from 'src/app/compliance-standards/ComplianceStandardsBrowserShell';
import {toComplianceTreeNodeId} from 'src/app/compliance-standards/complianceStandardTreeState';
import {useGetCustomComplianceStandardQuery} from 'src/redux/queries/complianceStandard';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

const ViewCustomComplianceStandardPage = () => {
  const {id} = useParams();
  const {data: standard} = useGetCustomComplianceStandardQuery(Number(id), {
    skip: !id,
  });

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Compliance}>
      <ComplianceStandardsBrowserShell
        variant="company"
        selectedId={standard ? toComplianceTreeNodeId(standard) : undefined}>
        <CompanyStandardForm id={Number(id)} mode="view" />
      </ComplianceStandardsBrowserShell>
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'page',
  path: PathUtility.CustomComplianceStandardsView(':id'),
  element: <ViewCustomComplianceStandardPage />,
  module: ModuleEnum.Compliance,
  operation: PermissionOperationEnum.View,
  isPrivate: true,
});

export default ViewCustomComplianceStandardPage;
